import {
    Divider as MuiDivider,
    DividerProps as MuiDividerProps,
} from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import classnames from "classnames";
import * as React from "react";

import { RelodeTheme } from "../styles";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {},
            gutterTop: {
                marginTop: theme.spacing(4),
            },
            gutterBottom: {
                marginBottom: theme.spacing(4),
            },
        }),
    { name: "Divider" }
);

interface DividerProps extends MuiDividerProps {
    gutterTop?: boolean;
    gutterBottom?: boolean;
}

export const Divider = (props: DividerProps) => {
    const {
        gutterTop = false,
        gutterBottom = false,
        classes: classesProp,
        ...other
    } = props;
    const classes = useStyles(props);

    const gutterClasses = classnames({
        [classes.gutterTop]: gutterTop,
        [classes.gutterBottom]: gutterBottom,
    });

    return (
        <MuiDivider
            className={gutterClasses}
            classes={classesProp}
            {...other}
        />
    );
};
